import * as angular from "angular";
import "./tooltip.scss";
import { TooltipService } from "./tooltip.service";

interface IDirectiveScope extends angular.IScope {
    title: "string",
    fixedPosition: '=',
    titleClass: '@',

    createTooltip(event?: JQueryEventObject): any;
    removeTooltip(event?: JQueryEventObject);

    getDirection(): string;
    tooltipElement: JQuery;

    stringContains(searchString: string, findString: string);
    stringStartsWith(searchString: string, findString: string);

    calculatePosition(x: any, y: any);
    updateTooltip(title: string);
}

// https://github.com/Intellipharm/angular-tooltips/tree/master/src
export class TooltipDirectiveAJS implements angular.IDirective {

    restrict = "A";
    scope = {
        title: '@',
        fixedPosition: '<',
        titleClass: '@',
    }

    link: ($scope: IDirectiveScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => void;

    constructor($timeout: angular.ITimeoutService, $compile: angular.ICompileService, tooltipService: TooltipService) {

        TooltipDirectiveAJS.prototype.link = ($scope: IDirectiveScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            $scope.createTooltip = (event?: JQueryEventObject) => {

                if ($attrs.title || $attrs.tooltip) {
                    var direction = $scope.getDirection();

                    // create the tooltip
                    $scope.tooltipElement = angular.element('<div>').addClass('angular-tooltip').addClass($scope.titleClass);

                    // append to the body
                    angular.element(document).find('body').append($scope.tooltipElement);

                    // update the contents and position
                    $scope.updateTooltip($attrs.title || $attrs.tooltip);

                    // Disable animation
                    if ($attrs.tooltipNoAnimate !== undefined) {
                        $scope.tooltipElement.addClass('no-animate');
                    }

                    // show
                    $scope.tooltipElement.addClass('angular-tooltip-fade-in');
                }
            };

            $scope.updateTooltip = (title: string) => {
                // insert html into tooltip
                $scope.tooltipElement.html(title);

                // compile html contents into angularjs
                $compile($scope.tooltipElement.contents())($scope);

                // calculate the position of the tooltip
                var pos = $scope.calculatePosition($scope.tooltipElement, $scope.getDirection());
                $scope.tooltipElement.addClass('angular-tooltip-' + pos.direction).css(pos);

                // stop the standard tooltip from being shown
                $timeout(function () {
                    $element.removeAttr('ng-attr-title');
                    $element.removeAttr('title');
                });
            };

            // if the title changes the update the tooltip
            $scope.$watch('title', (newTitle: string) => {
                if ($scope.tooltipElement) {
                    $scope.updateTooltip(newTitle);
                }
            });

            // removes all tooltips from the document to reduce ghosts
            $scope.removeTooltip = (event: JQueryEventObject) => {
                //return;

                var tooltip = angular.element(document.querySelectorAll('.angular-tooltip'));
                // tooltip.removeClass('angular-tooltip-fade-in');

                // $timeout(function() {
                tooltip.remove();
                // }, 300);
            };

            // gets the current direction value
            $scope.getDirection = () => {
                return $element.attr('tooltip-direction') || $element.attr('title-direction') || 'top';
            };

            // calculates the position of the tooltip
            $scope.calculatePosition = (tooltip, direction: string) => {
                var tooltipBounding = tooltip[0].getBoundingClientRect();
                var elBounding = $element[0].getBoundingClientRect();
                var scrollLeft = window.scrollX || document.documentElement.scrollLeft;
                var scrollTop = window.scrollY || document.documentElement.scrollTop;
                var arrow_padding = 12;
                var pos: { left?: any, top?: any, direction?: string } = {};
                var newDirection = null;

                // calculate the left position
                if ($scope.stringStartsWith(direction, 'left')) {
                    pos.left = elBounding.left - tooltipBounding.width - (arrow_padding / 2) + scrollLeft;
                }
                else if ($scope.stringStartsWith(direction, 'right')) {
                    pos.left = elBounding.left + elBounding.width + (arrow_padding / 2) + scrollLeft;
                }
                else if ($scope.stringContains(direction, 'left')) {
                    pos.left = elBounding.left - tooltipBounding.width + arrow_padding + scrollLeft;
                }
                else if ($scope.stringContains(direction, 'right')) {
                    pos.left = elBounding.left + elBounding.width - arrow_padding + scrollLeft;
                }
                else {
                    pos.left = elBounding.left + (elBounding.width / 2) - (tooltipBounding.width / 2) + scrollLeft;
                }

                // calculate the top position
                if ($scope.stringStartsWith(direction, 'top')) {
                    pos.top = elBounding.top - tooltipBounding.height - (arrow_padding / 2) + scrollTop;
                }
                else if ($scope.stringStartsWith(direction, 'bottom')) {
                    pos.top = elBounding.top + elBounding.height + (arrow_padding / 2) + scrollTop;
                }
                else if ($scope.stringContains(direction, 'top')) {
                    pos.top = elBounding.top - tooltipBounding.height + arrow_padding + scrollTop;
                }
                else if ($scope.stringContains(direction, 'bottom')) {
                    pos.top = elBounding.top + elBounding.height - arrow_padding + scrollTop;
                }
                else {
                    pos.top = elBounding.top + (elBounding.height / 2) - (tooltipBounding.height / 2) + scrollTop;
                }

                // check if the tooltip is outside the bounds of the window
                if ($scope.fixedPosition) {
                    if (pos.left < scrollLeft) {
                        newDirection = direction.replace('left', 'right');
                    }
                    else if ((pos.left + tooltipBounding.width) > (window.innerWidth + scrollLeft)) {
                        newDirection = direction.replace('right', 'left');
                    }

                    if (pos.top < scrollTop) {
                        newDirection = direction.replace('top', 'bottom');
                    }
                    else if ((pos.top + tooltipBounding.height) > (window.innerHeight + scrollTop)) {
                        newDirection = direction.replace('bottom', 'top');
                    }

                    if (newDirection) {
                        return $scope.calculatePosition(tooltip, newDirection);
                    }
                }

                pos.left += 'px';
                pos.top += 'px';
                pos.direction = direction;

                return pos;
            };

            $scope.stringStartsWith = (searchString, findString) => {
                return searchString.substr(0, findString.length) === findString;
            };

            $scope.stringContains = (searchString, findString) => {
                return searchString.indexOf(findString) !== -1;
            };

            var showTootipViaAttr = $element.attr('tooltip-show');
            if (showTootipViaAttr != null) {
                setTimeout(() => {
                    if (showTootipViaAttr == "true") {
                        $scope.createTooltip();
                    }
                    else {
                        $scope.removeTooltip();
                    }
                }, 150);
            }
            else if ($attrs.title || $attrs.tooltip) {
                // attach events to show tooltip
                $element.on("mouseenter" as any, $scope.createTooltip);
                $element.on("mouseleave", $scope.removeTooltip);
            } else {
                // remove events
                $element.off("mouseenter" as any, $scope.createTooltip);
                $element.off("mouseleave", $scope.removeTooltip);
            }

            $element.on('destroy', $scope.removeTooltip);
            $scope.$on('$destroy', $scope.removeTooltip as any);

            //$scope.$on("$destroy", () => {
            //    $element.off("keydown");
            //});
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout: angular.ITimeoutService, $compile: angular.ICompileService, tooltipService: TooltipService) => new TooltipDirectiveAJS($timeout, $compile, tooltipService);

        directive.$inject = ["$timeout", "$compile", "tooltipService"];

        return directive;
    }
}
